const swiper = new Swiper('.mySwiper', {
  speed: 1500,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 20,
  navigation: {
    nextEl: '.section__ratings .swiper-button-next',
    prevEl: '.section__ratings .swiper-button-prev',
  },
});

const swiperProcedureClone = new Swiper('.swiperProcedureClone', {
  speed: 1500,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 25,
});

const swiperProcedure = new Swiper('.swiperProcedure', {
  speed: 1500,
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.section__procedure-nav .swiper-button-next',
    prevEl: '.section__procedure-nav .swiper-button-prev',
  },
});

function synchronizeSwipers(sourceSwiper, targetSwiper) {
  sourceSwiper.on('slideChange', () => {
    const realIndex = sourceSwiper.realIndex;
    targetSwiper.slideToLoop(realIndex);
  });
}

synchronizeSwipers(swiperProcedure, swiperProcedureClone);
synchronizeSwipers(swiperProcedureClone, swiperProcedure);

const swiperTreatments = new Swiper('.swiperTreatments', {
  speed: 1500,
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 30,
  navigation: {
    nextEl: '.section__treatments .swiper-button-next',
    prevEl: '.section__treatments .swiper-button-prev',
  },
});

const preventBehavior = () => {
  const link = document.querySelectorAll("a");

  link.forEach((val, idx) => {
    val.addEventListener("click", (ev) => {
      if (val.getAttribute("href") === "#") {
        ev.preventDefault();
      }
    });
  });
};

preventBehavior();


document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('header');
  const menuToggle = document.querySelector('.menu-toggle');
  const firstSection = document.getElementById('home-banner');

  window.addEventListener('scroll', () => {
    const firstSectionBottom = firstSection.getBoundingClientRect().bottom;
    if (firstSectionBottom <= 0) {
      header.classList.add('fixed');
      menuToggle.classList.add('fixed');
    } else {
      header.classList.remove('fixed');
      menuToggle.classList.remove('fixed');
    }
  });
});